module.exports = __webpack_public_path__ + "static/img/shi2_1.8c7337d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shi2_1.png
// module id = Ek7S
// module chunks = 1